import { render, staticRenderFns } from "./ReturnTagPrinter.vue?vue&type=template&id=61f748ae"
import script from "./ReturnTagPrinter.vue?vue&type=script&lang=js"
export * from "./ReturnTagPrinter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports